import(/* webpackMode: "eager" */ "/app/src/app/api-docs/page.tsx");
